/* Ürün kartı altındaki renk swatch'lari:
   - Üzerine gelince kartin gorseli o renkle onizlenir (tiklamaya gerek yok)
   - Fare ayrilinca secili renge, secim yoksa ilk gorsele doner
   - Tiklayinca renk kalici olarak secilir ve kart linki o varyanta gider */

if (!customElements.get('card-swatches')) {
  class CardSwatches extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('mouseover', this.onHover.bind(this));
      this.addEventListener('mouseout', this.onLeave.bind(this));
      this.addEventListener('focusin', this.onHover.bind(this));
      this.addEventListener('focusout', this.onLeave.bind(this));
    }

    get card() {
      return this.closest('[data-swatch-card]');
    }

    get image() {
      var card = this.card;
      if (!card) return null;
      // Magazanin kendi kartlarinda ana gorsel ".media img", Prestige'den tasinan
      // kartlarda ".product-card__image--primary". Ikisini de destekliyoruz;
      // bir kartta yalnizca biri bulundugu icin catisma olmuyor.
      return card.querySelector(
        '.media img:not(.product-second-img), .product-card__image--primary'
      );
    }

    // Kartın ilk (varsayılan) görselini bir kez saklar
    rememberOriginal(image) {
      if (!image || image.dataset.swatchOriginal) return;
      image.dataset.swatchOriginal = image.currentSrc || image.src || '';
      image.dataset.swatchOriginalSrcset = image.srcset || '';
    }

    setImage(image, src, srcset) {
      if (!image || !src) return;
      image.src = src;
      image.srcset = srcset || '';
      // lazysizes eski kaynağı geri yüklemesin
      image.removeAttribute('data-src');
      image.removeAttribute('data-srcset');
      image.removeAttribute('data-original');
    }

    onHover(event) {
      var button = event.target.closest('.card-swatch');
      if (!button || !button.dataset.swatchImage) return;

      var image = this.image;
      var card = this.card;
      if (!image || !card) return;

      this.rememberOriginal(image);

      // Önizleme sırasında hover'daki ikinci fotoğraf devreye girmesin
      card.classList.add('swatch-previewing');
      this.setImage(image, button.dataset.swatchImage, button.dataset.swatchSrcset);
    }

    onLeave(event) {
      // Fare hâlâ swatch listesinin içindeyse bir şey yapma
      if (event.relatedTarget && this.contains(event.relatedTarget)) return;

      var image = this.image;
      var card = this.card;
      if (!image || !card) return;

      card.classList.remove('swatch-previewing');

      var selected = this.querySelector('.card-swatch.is-selected');
      if (selected && selected.dataset.swatchImage) {
        this.setImage(image, selected.dataset.swatchImage, selected.dataset.swatchSrcset);
        return;
      }

      if (image.dataset.swatchOriginal) {
        this.setImage(image, image.dataset.swatchOriginal, image.dataset.swatchOriginalSrcset);
        card.classList.remove('swatch-selected');
      }
    }

    onClick(event) {
      var button = event.target.closest('.card-swatch');
      if (!button) return;
      // "+N" rozeti gerçek bir renk değil, ürün sayfasına giden düz bir link:
      // önizleme/seçim mantığına girmesin, tarayıcı linki normal şekilde açsın.
      if (button.classList.contains('card-swatch--count')) return;

      event.preventDefault();
      event.stopPropagation();

      this.querySelectorAll('.card-swatch').forEach(function (item) {
        item.classList.remove('is-active', 'is-selected');
      });
      button.classList.add('is-active', 'is-selected');

      var card = this.card;
      var image = this.image;
      if (!card || !image || !button.dataset.swatchImage) return;

      this.rememberOriginal(image);
      this.setImage(image, button.dataset.swatchImage, button.dataset.swatchSrcset);

      // Renk seçilince hover'daki ikinci fotoğraf eski rengi göstermesin
      card.classList.add('swatch-selected');
      card.classList.remove('swatch-previewing');

      var url = button.dataset.swatchUrl;
      if (url) {
        card.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
          link.href = url;
        });
      }
    }
  }

  customElements.define('card-swatches', CardSwatches);
}
